import { formatDate } from '../format';
import { t } from '../i18n/pt-BR';
import { usePlan } from '../plan/PlanContext';
import { planStatusLabel } from './chips';

/** Seletor de plano do cabeçalho: rascunho ou publicado, com a situação no próprio texto da opção. */
export function PlanSelector() {
  const { plans, selected, select, isLoading, error } = usePlan();

  if (isLoading) return <span className="hint">{t.plan.loading}</span>;
  if (error || !plans.length) return <span className="hint">{t.plan.none}</span>;

  return (
    <div className="plan-select">
      <label htmlFor="plan-select">{t.plan.selectorLabel}</label>
      <select
        id="plan-select"
        className="select"
        value={selected?.['nr-plano'] ?? ''}
        onChange={(e) => select(Number(e.target.value))}
      >
        {plans.map((p) => (
          <option key={p['nr-plano']} value={p['nr-plano']}>
            #{p['nr-plano']} · {p.descricao} · {formatDate(p['dt-ini'])} · {planStatusLabel(p.situacao)}
          </option>
        ))}
      </select>
    </div>
  );
}
